import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Sticky promotional bar above the main header.
 * - Auto-rotates 3 messages (offer, code, free shipping)
 * - Can be dismissed (state stored in sessionStorage so it reappears next session)
 */
const SESSION_KEY = "top_banner_dismissed";

export default function TopAnnouncementBar() {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(SESSION_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [idx, setIdx] = useState(0);

  const messages = [
    t("banner.launch_offer"),
    t("banner.promo_code"),
    t("banner.free_shipping"),
  ];

  useEffect(() => {
    if (dismissed) return;
    const id = setInterval(() => {
      setIdx((i) => (i + 1) % messages.length);
    }, 4500);
    return () => clearInterval(id);
  }, [dismissed, messages.length]);

  if (dismissed) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div
      className="relative bg-gradient-to-r from-[#C5CDD8] via-white to-[#C5CDD8] text-[#001F3F] border-b border-white/10 overflow-hidden"
      data-testid="top-announcement-bar"
    >
      <div className="max-w-7xl mx-auto px-12 py-2.5 text-center text-xs sm:text-sm font-bold uppercase tracking-[0.18em]">
        <span
          key={idx}
          className="inline-block animate-[fadeIn_0.4s_ease-out]"
          data-testid={`banner-message-${idx}`}
        >
          {messages[idx]}
        </span>
      </div>
      <button
        type="button"
        onClick={dismiss}
        className="absolute top-1/2 -translate-y-1/2 right-2 sm:right-4 p-1.5 hover:bg-[#001F3F]/10 transition"
        aria-label={t("banner.dismiss")}
        data-testid="top-banner-dismiss"
      >
        <X size={14} strokeWidth={2.5} />
      </button>
    </div>
  );
}
